var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Dialog" },
    [
      _c(
        "el-dialog",
        _vm._g(
          _vm._b(
            {
              attrs: {
                visible: _vm.innerVisible,
                width: _vm.localWidth,
                center: _vm.center,
                "destroy-on-close": "",
                "close-on-click-modal": _vm.modelClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.innerVisible = $event
                },
                close: _vm.handleCancel,
              },
              scopedSlots: _vm._u(
                [
                  _vm.isFooter
                    ? {
                        key: "footer",
                        fn: function () {
                          return [
                            !_vm.footSlot
                              ? _c(
                                  "div",
                                  { staticClass: "Dialog__footer" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "primary",
                                        },
                                        on: { click: _vm.handleConfirm },
                                      },
                                      [_vm._v(_vm._s(_vm.confirmText))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { size: "mini" },
                                        on: { click: _vm.handleCancel },
                                      },
                                      [_vm._v("取消")]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  { staticClass: "Dialog__footer" },
                                  [_vm._t("footer")],
                                  2
                                ),
                          ]
                        },
                        proxy: true,
                      }
                    : null,
                ],
                null,
                true
              ),
            },
            "el-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }